<span [ngSwitch]="status">
  <span class="badge bg-secondary text-light" *ngSwitchCase="'TO_RECEIVE'">À recevoir</span>
  <span class="badge bg-success text-light" *ngSwitchCase="'RECEIVED'">Réceptionnée</span>
</span>